import React, { useEffect, useState } from "react";

const GPS = (props) => {
  const [coordinate, setCoordinate] = useState({
    log: null,
    lat: null,
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {

      setCoordinate((prev) => ({
        ...prev,
        log: position.coords.longitude,
        lat: position.coords.latitude,
      }));

      props.setLogi((prev) => ({
        ...prev,
        logi: position.coords.longitude,
        lati: position.coords.latitude,
      }));

    });
  });

  return (
    <div>
      {/* <div>Longitude: {lat}</div><br /><div>Latitude: {lon}</div> */}
    </div>
  );
};
export default GPS;
